<template>
  <v-container fluid>
    <v-dialog 
      v-model = "deleteEntityDialog" 
      width="400">
      <v-card v-if = "selected && selected.length">
        <v-card-title
          class="headline"
          primary-title>
          Delete <span style="padding-left: 5px; font-size: 70%; font-weight: bold"> "{{ selected.length === 1 ? selected.map(entity => entity.name).join(', ') : '' }}"</span>
        </v-card-title>
        <v-card-text>
          Are you sure you want to delete this {{ selected.length > 1 ? selected.length : '' }} Entit{{ selected.length > 1 ? 'ies' : 'y' }} ?
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn
            :loading = "addButtonLoader"
            color="error"
            outline
            @click="deleteEntities">
            Delete
          </v-btn>
          <v-btn
            color = "black"
            class = "white--text"
            @click="deleteEntityDialog = false">
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <add-entity
                ref = "addEntity"
                :put = "selected && selected.length && selected.length === 1 ? selected[0] : null"
                @loading = "addButtonLoader = $event"
                @success = "createEntityDialog = false" />
    <v-layout 
      row 
      wrap>
      <h1>My Entities</h1>
      <v-spacer />
      <app-actions />
    </v-layout>
    <v-flex xs12>
      <v-card class = "card-curvey">
        <v-layout 
          row 
          wrap>
          <v-flex xs4>
            <v-text-field
              v-model = "queries.q"
              placeholder = "Search By Name.."
              intentend-icon = "search"
              outline
              @input="getEntities(true)" />
          </v-flex>
          <v-spacer />
          <v-btn
            :disabled = "!selected || !selected.length || selected.length !== 1"
            :loading = "!!(addButtonLoader && selected.length)"
            color = "blue-grey"
            class = "nlp-nav-btn"
            small
            outline
            @click = "openAddDialog(false)">
            <v-icon>edit</v-icon>
            Rename
          </v-btn>
          <v-btn
            :disabled = "!selected || !selected.length || selected.length !== 1"
            color = "blue-grey"
            class = "nlp-nav-btn"
            small
            outline
            @click = "syncEntity">
            <v-icon>sync</v-icon>
            Sync
          </v-btn>
          <v-btn
            :disabled = "!selected || !selected.length"
            color = "blue-grey"
            class = "nlp-nav-btn"
            small
            outline
            @click = "deleteEntityDialog = true">
            <span 
              class="botter-trash-icon" 
              style="padding-right: 6px"/>
            Delete
          </v-btn>
          <v-btn
            :loading = "!!(addButtonLoader)"
            color = "blue-grey"
            class = "nlp-nav-btn"
            small
            outline
            @click = "openAddDialog(true)">
            <v-icon>add</v-icon>
            New Entity
          </v-btn>

        </v-layout>
        <v-flex xs12>
          <v-data-table
            v-model="selected"
            :headers="headers"
            :items="queriedEntities"
            :loading="loaders.list"
            item-key="name"
            hide-actions
            single-select
            no-data-text = "No Entities Available"
            class="elevation-1 nlp-data-table">
            <template 
              slot="items" 
              slot-scope = "props" > 
              <tr v-if = "props.item.name">
                <td>
                  <v-checkbox
                    v-model="props.selected"
                    primary
                    hide-details
                  />
                </td>
                <td>
                  <span
                    v-if = "props.item.type === 'list'"
                    class = "primary--text pointer-cursor"
                    @click = "selectEntity(props.item)">
                    <a style="color: mediumblue; text-decoration: underline" >{{ props.item.name }}</a>
                  </span>
                  <span
                    v-else>
                    {{ props.item.name }}
                  </span>
                  <a
                   v-if = "props.item.type === 'list'"
                   :href="`/nlp/app/${$store.state.nlp.selectedApp.id}/entities/${props.item.id}`"
                   target="_blank"
                   class="ml-1">
                    <v-icon color="primary" size="15">open_in_new</v-icon>
                  </a>
                </td>
                <td class="text-center" style="text-transform: capitalize">{{ props.item.type.split('_').join(' ') }}</td>
              </tr>
            </template>
          </v-data-table>
        </v-flex>
        <v-divider />
      <v-layout 
        row 
        wrap >
        <v-flex xs10>
          <v-layout 
            justify-center 
            align-content-center 
            style = "padding-top: 15px">
            <v-pagination
              slot = "footer"
              v-model="pagination.page"
              :length="paginationCount"
              :disabled="loaders.list"
              style = "width: auto !important; margin: auto !important"
              @input = "getEntities(false)"/>
          </v-layout>
        </v-flex>
        <v-flex 
          xs2 
          align-self-center>
          <v-spacer />
          <div style="text-align: right"><small>Items Per Page</small></div>
          <v-select
            v-model = "pagination.per_page"
            :items = "[5,10,15,20,25]"
            :disabled="loaders.list"
            style="width: 80px; float: right"
            outline
            @input = "getEntities(false)"/>
        </v-flex>
      </v-layout>
      </v-card>
    </v-flex>
  </v-container>
</template>

<script>
import AddEntity from '../../../../components/nlp/entities/AddEntities.vue'
import AppActions from '../../common/AppActions'
export default {
  name: 'Nlp',
  components: {
    AddEntity,
    AppActions
  },
  data() {
    return {
      queries: {
        q: ''
      },
      pagination: {
        page: 1,
        per_page: 15
      },
      loaders: {
        list: true
      },
      createEntityDialog: false,
      deleteEntityDialog: false,
      addButtonLoader: false,
      selected: [],
      headers: [
        { text: 'Select', value: 'id', align: 'left', sortable: false},
        {
          text: 'Entity Name',
          align: 'left',
          sortable: true,
          value: 'name'
        },
        { text: 'Type', value: 'type', align: 'center' },
      ]
    }
  },
  computed: {
    queriedEntities() {
      // return this.$store.getters['nlp/intents/query'](this.queries.q)
      return this.$store.state.nlp.entities
    },
    paginationCount() {
      return this.queriedEntities && this.queriedEntities.length
        ? Math.ceil(
            this.$store.state.nlp.entitiesPagination.entities.count /
              this.pagination.per_page
          )
        : 0
    }
  },
  watch: {
     selected: {
       deep: true,
       handler(val) {
         if(val && val.length && val.length > 1) {
           this.selected = [val[val.length - 1]]
         }
       }
     }
  },
  mounted() {
    // get entities
    this.getEntities()
  },
  methods: {
    // cloneEntity() {
    //   this.addButtonLoader = true
    //   const payload = this.$_.pick(this.selected[0], ['name'])
    //   this.$store.dispatch('nlp/entities/add', payload).then(()=>{
    //     this.addButtonLoader = false
    //   }).catch(()=> {
    //     this.addButtonLoader = false
    //   })
    // },
    getEntities(resetPagination) 
    {
      this.loaders.list = true
      if(resetPagination) {
        this.pagination.page = 1
      }
      let params = { ...this.pagination, hideLoading: true }
      if(this.queries.q && this.queries.q.length) params['filter[name]'] = this.queries.q
      this.$store.dispatch('nlp/entities/get', params)
      .then(()=>{
        this.loaders.list = false
      })
      .catch(err => {
        this.$store.dispatch('setErrorMessage', true)
        this.loaders.list = false
      })
    },
    openAddDialog(reset = true) {
      if(reset) this.selected = []
      this.$refs.addEntity.openDialog()
    },
    addNewEntity() {
      if (this.$refs.addEntity) this.$refs.addEntity.submit()
    },
    selectEntity(entity) {
      this.$store.dispatch('nlp/entities/select', entity)
      this.$router.push(`/nlp/app/${this.$route.params.id}/entities/${entity.id}`)
    },
    syncEntity() {
      this.$store.dispatch('setLoader', true)
      this.$store.dispatch('nlp/entities/single/sync', this.selected[0].id).then(()=>{
        this.$store.dispatch('setLoader', false)
      }).catch(()=>{
        this.$store.dispatch('setLoader', false)
        this.$store.dispatch('setErrorMessage', true)
      })
    },
    deleteEntities() {
      this.$store.dispatch('setLoader', true)
      this.$store
        .dispatch('nlp/entities/delete/single', this.selected[0].id)
        .then(() => {
          this.deleteEntityDialog = false
          this.$store.dispatch('setSnackbar', {
            text: `Deleted Successfully`,
            color: 'success'
          })
          this.selected = []
          this.$store.dispatch('setLoader', false)
        })
        .catch((err) => {
          // console.log(err)
          this.deleteEntityDialog = false
          this.$store.dispatch('setErrorMessage', true)
          this.$store.dispatch('setLoader', false)
        })
    }
  }
}
</script>

<style lang="scss" src="../../../../assets/sass/commponents/nlp.scss">
</style>
<style lang="css">
.entities-form-container-tag {
	width: 100%;
	display: flex;
	padding-left: 20%;
	align-items: center;
}
.entities-form-parrier-tag {
	width: calc(30%);
}
</style>
